<script setup>
import { inject, provide, computed } from 'vue';
import { SidebarControl } from './provider';
import SidebarGroup from './SidebarGroup.vue';

defineProps({
  group: { type: Object, required: true },
});

// Re-provide the sidebar context with an always-expanded flag so the reused
// SidebarGroup renders its header + children (pills, folders, teams, channels,
// labels) inline instead of the collapsed icon/popover form used in the rail.
const parentContext = inject(SidebarControl);
provide(SidebarControl, {
  ...parentContext,
  isCollapsed: computed(() => false),
});
</script>

<template>
  <div
    class="organic-submenu hidden md:flex flex-col flex-shrink-0 w-[236px] h-full min-h-0 overflow-y-auto no-scrollbar bg-n-background ltr:border-r rtl:border-l border-n-weak px-3 py-3"
  >
    <h2
      class="font-caprasimo text-2xl leading-none px-2 pt-1 pb-4 text-n-slate-12 truncate"
    >
      {{ group.label }}
    </h2>
    <ul class="flex flex-col gap-1 m-0 list-none min-w-0">
      <SidebarGroup v-bind="group" hide-header />
    </ul>
  </div>
</template>
